import React from "react";
import { toast } from "sonner";
import { Modal, Btn } from "@/components/erp/ui";
import { Copy, ExternalLink, MessageCircle } from "lucide-react";
import { poLink, sendPoWa } from "@/components/erp/purchasing/poShare";

const fmt = (s) => (s ? new Date(s).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

// Link PDF PO yang sudah dikirim ke supplier
export const PoLinkModal = ({ po, onClose, onResent }) => {
  if (!po) return null;
  const url = poLink(po.share_token);
  return (
    <Modal open onClose={onClose} title={`Link PO · ${po.code}`}
      footer={<><Btn variant="ghost" onClick={onClose}>Tutup</Btn><Btn data-testid="po-link-resend" onClick={async () => { await sendPoWa(po); onResent(); }}><MessageCircle className="w-4 h-4" /> Kirim ulang WA</Btn></>}>
      <p className="text-sm text-slate-600 mb-2">Terkirim ke {po.supplier_name} {fmt(po.wa_sent_at)}{po.wa_sent_by ? ` oleh ${po.wa_sent_by}` : ""}. Supplier bisa membuka PDF tanpa login.</p>
      <div className="flex gap-2 items-center">
        <input readOnly value={url} data-testid="po-link-url" className="flex-1 min-w-0 border border-slate-300 rounded-lg px-3 py-2 text-xs font-mono" />
        <button type="button" data-testid="po-link-copy" onClick={() => { navigator.clipboard?.writeText(url); toast.success("Link disalin"); }} className="p-2 rounded-lg border"><Copy className="w-4 h-4" /></button>
        <a href={url} target="_blank" rel="noreferrer" data-testid="po-link-open" className="p-2 rounded-lg border"><ExternalLink className="w-4 h-4" /></a>
      </div>
    </Modal>
  );
};
